"use client";

import useNumber from "@/hooks/number";
import { Button } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import Link from "next/link";
import routes from "@/app.route";
import useCart from "@/stores/cart";
import Image from "next/image";
import SparkleEffect from "@/components/sparkle-effect";
import { getWithGstAmount } from "@/lib/gst";

export default function CartMobile() {
  const { currency } = useNumber();
  const { items, increment, decrement, removeItem } = useCart();
  const total = items.reduce(
    (acc, i) =>
      acc + getWithGstAmount(i.price, i.gst_rate) * Number(i.quantity),
    0,
  );
  const totalItems = items.reduce((acc, i) => acc + Number(i.quantity), 0);

  return (
    <>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <h1 className="text-2xl">My Shopping Cart</h1>
      </div>
      <div className="space-y-4">
        <div className="bg-white divide-y divide-zinc-200">
          {items.map((variant, i) => (
            <div key={i} className="p-4">
              <Link
                href={routes.product.url.replace(
                  ":slug",
                  variant.product.handle,
                )}
                className="inline-flex gap-x-4 items-center hover:text-primary"
              >
                {variant.product.featured_image && (
                  <Image
                    src={variant.product.featured_image.original_url}
                    alt={variant.product.title}
                    width={64}
                    height={64}
                  />
                )}
                <div>
                  <div className="font-semibold">{variant.product.title}</div>
                  <div>
                    <span>
                      {currency(
                        getWithGstAmount(variant.price, variant.gst_rate),
                      )}
                    </span>
                    &nbsp;
                    {variant.compare_at_price && (
                      <span className="line-through text-sm text-zinc-500">
                        {currency(variant.compare_at_price)}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
              <div className="flex justify-between items-center gap-3">
                <Button
                  onClick={() => {
                    removeItem(`${variant.id}`);
                  }}
                >
                  Delete
                </Button>

                <div className="flex flex-nowrap">
                  <button
                    disabled={Number(variant.quantity) == 1}
                    onClick={() => decrement(`${variant.id}`)}
                    type="button"
                    className={`rounded text-zinc-500 bg-zinc-100 shrink-0 size-[30px] grid place-items-center ${Number(variant.quantity) == 1 ? "cursor-no-drop" : "cursor-pointer"}`}
                  >
                    <RemoveRoundedIcon fontSize="small" />
                  </button>
                  <div className="size-[30px] grid place-items-center px-1">
                    {variant.quantity}
                  </div>
                  <button
                    onClick={() => increment(`${variant.id}`)}
                    type="button"
                    className="rounded text-white shrink-0 size-[30px] grid place-items-center cursor-pointer bg-primary"
                  >
                    <AddRoundedIcon fontSize="small" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white p-4 mb-[70px]">
          <div className="flex justify-between items-baseline gap-3 py-1">
            <div>Total ({totalItems})</div>
            <div className="font-semibold text-lg">{currency(total)}</div>
          </div>
          <div className="flex justify-between items-baseline gap-3 py-1">
            <div>Shipping</div>
            <div>Calculate at Checkout</div>
          </div>
        </div>
        <div className="bg-white fixed left-0 right-0 bottom-0 p-4 border-t border-zinc-200">
          <SparkleEffect>
            <Button href={routes.checkout.url} variant="contained" fullWidth>
              Proceed to Checkout
            </Button>
          </SparkleEffect>
        </div>
      </div>
    </>
  );
}
